import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'formatIban',
    standalone: false
})
export class FormatIbanPipe implements PipeTransform{
    transform(value: string):string {
        return (value.match(/.{1,4}/g))!.join(" ");
    }

}